export default {
  init() {
    // JavaScript to be fired on the contact us page

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/contact.js